import { usePlanonReference, FIELD_LABEL_CLS, FIELD_INPUT_CLS } from './usePlanonReference';

/**
 * A dropdown backed by one PicklistWelcomeQuery group. Unlike RefSelect the
 * value is the option Name (text), because picklist FreeStrings are sent to
 * Planon as their Name rather than a syscode.
 */
export function PicklistSelect({
  group,
  label,
  value,
  onChange,
}: {
  group: string;
  label: string;
  value: string | null;
  onChange: (v: string | null) => void;
}) {
  const q = usePlanonReference('picklist');
  const entries = (q.data?.entries ?? []).filter((e) => e.group_code === group);
  const known = value != null && entries.some((e) => e.label === value);
  return (
    <label className="block">
      <span className={FIELD_LABEL_CLS}>{label}</span>
      <select
        className={FIELD_INPUT_CLS}
        value={value ?? ''}
        disabled={q.isLoading}
        onChange={(e) => onChange(e.target.value || null)}
      >
        <option value="">{q.isLoading ? 'Loading…' : 'Choose…'}</option>
        {value != null && !known ? <option value={value}>{value} — not in cached list</option> : null}
        {entries.map((e) => (
          <option key={e.syscode} value={e.label}>
            {e.label}
          </option>
        ))}
      </select>
    </label>
  );
}
